<template>
    <div class="menu-topic" v-bind:class="{active: item.active, hover: isHover && !item.active}" @mouseover="mouseOver()" @mouseout="mouseOver()">
      <div><img class="icon" :src="isHover && !item.active ? item.img2 : item.img"/></div>
      <div style="width: 100%; padding-left: 8px;">
        <span>
          {{item.name}}
        </span>
      </div>
      <div><img class="icon-right" :src="isHover && !item.active ? item.img2 : item.img"/></div>
      <div><img class="arrow" :src="isHover && !item.active ? icons.ARROW_WHITE : icons.ARROW"/></div>
    </div>
</template>

<script>
import { ICONS } from '@/constants/help-center'
import { isMobileDevice } from '@/utils/device'

export default {
  name: 'MenuTopic',
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      isHover: false,
      icons: ICONS
    }
  },
  methods: {
    mouseOver () {
      if (!isMobileDevice()) this.isHover = !this.isHover
    }
  }
}
</script>
<style>
.centro-de-ayuda .menu-topic {
  background: #FFFFFF;
  border: 1.67837px solid #F2F2F2;
  box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
  border-radius: 4px;
  padding-top: 15px;
  padding-bottom: 6px;
  padding-left: 10px;
  max-width: 304px;
  margin-bottom: 8px;
  cursor: pointer;
  display: flex;
  margin-right: 10px;
}
.centro-de-ayuda .menu-topic.hover {
  background: #EFF1F4;
}
.centro-de-ayuda .menu-topic.active {
  border: 1.67837px solid #0855C4;
  box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
  border-radius: 4px;
}
.centro-de-ayuda .menu-topic span {
  font-family: 'Omnes Regular';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #454A6C;
  vertical-align: calc(100% - 15px);
}

.centro-de-ayuda .menu-topic img.arrow {
  float: right;
  padding: 8px 13px;
}
.centro-de-ayuda .menu-topic img.icon-right {
    display: none;
  }
@media only screen and (max-width: 768px) {
  .centro-de-ayuda .menu-topic {
    border-radius: 16px;
    margin-bottom: 10px;
    margin-right: 6px;
    padding-bottom: 0px;
    min-width: 130px;
    height: 135px!important;
    width: 48%;
  }
  .centro-de-ayuda .menu-topic.active {
    border-radius: 16px;
  }
  .centro-de-ayuda .menu-topic span {
    font-family: 'Omnes Regular';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    color: #454A6C;
    display: flex;
    align-items: flex-start;
    justify-content: left;
    height: 100%;
    margin-top: 10px;
  }
  .centro-de-ayuda .menu-topic img.arrow {
    display: none;
  }
  .centro-de-ayuda .menu-topic img.icon {
    display: none;
  }
  .centro-de-ayuda .menu-topic img.icon-right {
    display: flex;
    margin-top: 65px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/help-center/MenuTopic.vue